// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IRoleCreateDto
 */
export interface IRoleCreateDto {
    /**
     * 
     * @type {string}
     * @memberof IRoleCreateDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof IRoleCreateDto
     */
    level_type: IRoleCreateDtoLevelTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IRoleCreateDto
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof IRoleCreateDto
     */
    organization_id?: number;
    /**
     * 
     * @type {Set<number>}
     * @memberof IRoleCreateDto
     */
    granted_permission_ids: Set<number>;
    /**
     * 
     * @type {Set<number>}
     * @memberof IRoleCreateDto
     */
    role_ids_allowed_for_creation?: Set<number>;
    /**
     * 
     * @type {boolean}
     * @memberof IRoleCreateDto
     */
    self_creation_allowed?: boolean;
    /**
     * 
     * @type {Set<number>}
     * @memberof IRoleCreateDto
     */
    allowed_for_creation_by_role_ids?: Set<number>;
    /**
     * 
     * @type {number}
     * @memberof IRoleCreateDto
     */
    org_properties_state_config_id: number;
}

/**
* @export
* @enum {string}
*/
export enum IRoleCreateDtoLevelTypeEnum {
    ELEVATE = 'ELEVATE',
    GLOBAL = 'GLOBAL',
    PARTNER = 'PARTNER'
}


/**
 * Check if a given object implements the IRoleCreateDto interface.
 */
export function instanceOfIRoleCreateDto(value: object): value is IRoleCreateDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('level_type' in value) || value['level_type'] === undefined) return false;
    if (!('granted_permission_ids' in value) || value['granted_permission_ids'] === undefined) return false;
    if (!('org_properties_state_config_id' in value) || value['org_properties_state_config_id'] === undefined) return false;
    return true;
}

export function IRoleCreateDtoFromJSON(json: any): IRoleCreateDto {
    return IRoleCreateDtoFromJSONTyped(json, false);
}

export function IRoleCreateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IRoleCreateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'level_type': json['level_type'],
        'description': json['description'] == null ? undefined : json['description'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'granted_permission_ids': new Set(json['granted_permission_ids']),
        'role_ids_allowed_for_creation': json['role_ids_allowed_for_creation'] == null ? undefined : new Set(json['role_ids_allowed_for_creation']),
        'self_creation_allowed': json['self_creation_allowed'] == null ? undefined : json['self_creation_allowed'],
        'allowed_for_creation_by_role_ids': json['allowed_for_creation_by_role_ids'] == null ? undefined : new Set(json['allowed_for_creation_by_role_ids']),
        'org_properties_state_config_id': json['org_properties_state_config_id'],
    };
}

export function IRoleCreateDtoToJSON(json: any): IRoleCreateDto {
    return IRoleCreateDtoToJSONTyped(json, false);
}

export function IRoleCreateDtoToJSONTyped(value?: IRoleCreateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'level_type': value['level_type'],
        'description': value['description'],
        'organization_id': value['organization_id'],
        'granted_permission_ids': Array.from(value['granted_permission_ids'] as Set<any>),
        'role_ids_allowed_for_creation': value['role_ids_allowed_for_creation'] == null ? undefined : Array.from(value['role_ids_allowed_for_creation'] as Set<any>),
        'self_creation_allowed': value['self_creation_allowed'],
        'allowed_for_creation_by_role_ids': value['allowed_for_creation_by_role_ids'] == null ? undefined : Array.from(value['allowed_for_creation_by_role_ids'] as Set<any>),
        'org_properties_state_config_id': value['org_properties_state_config_id'],
    };
}

